import { render, staticRenderFns } from "./zeroAct.vue?vue&type=template&id=54aea418&scoped=true&"
import script from "./zeroAct.vue?vue&type=script&lang=js&"
export * from "./zeroAct.vue?vue&type=script&lang=js&"
import style0 from "./zeroAct.vue?vue&type=style&index=0&id=54aea418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aea418",
  null
  
)

export default component.exports